import { combineReducers } from '@reduxjs/toolkit'

import domainSlice from '@/features/domain'

export const rootReducer = combineReducers({
  domain: domainSlice,
})
